/**
 * 404 — stands in for rent_management_app/lib/screens/error_screen.dart
 * (GoRouter's `errorBuilder`, app_router.dart:60).
 */
import { Link } from 'react-router-dom';
import { ROUTES } from '../routes/paths';

export function NotFoundPage(): React.JSX.Element {
  return (
    <section>
      <h1>Page not found</h1>
      <p>
        <Link to={ROUTES.landing}>Go home</Link>
      </p>
    </section>
  );
}

export default NotFoundPage;
